import styled from 'styled-components'
import { Box, Typography } from 'src/components'
import { motion } from 'framer-motion'

export const OverCard = styled(motion(Box))<{
    background: string
    address: boolean
}>`
    background: url(${(props) => props.background}) no-repeat center/cover;
    width: 90%;
    height: auto;
    margin-bottom: 31px;
    border-radius: 15px;
    display: flex;
    position: relative;
    flex-direction: column-reverse;
    justify-content: space-between;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 98%;
        height: auto;
        flex-direction: column-reverse;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1074px;
        flex-direction: ${({ address }) => (address ? 'row' : 'row-reverse')};
        height: auto;
    }
`
export const TypographySection = styled(Box)`
    width: 100%;
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 48%;
        height: 90%;
    }
`

export const OverSpan = styled.span`
    position: absolute;
    background-size: cover;
    background-position: center center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 15px;
    opacity: 0.7;
    background-image: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
    );
`

export const ImageSection = styled(Box)`
    width: 98%;
    height: 90%;
    z-index: 20;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 68%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 48%;
    }
`
export const Image = styled.img`
    width: 100%;
    height: 100%;
    border-radius: 20px;
    object-fit: contain;
`
export const TitleContent = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    z-index: 20;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const TitleSection = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 18px;
    text-align: center;
    color: ${({ theme }) => theme.colors.white};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 24px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 21px;
    }
`
export const ContentSection = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 12px;
    text-align: start;
    color: ${({ theme }) => theme.colors.white};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 18px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 19px;
    }
`
